"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _immutable = require("immutable");

var OnboardingRecord = (0, _immutable.Record)({
  name: null,
  active: false,
  onStep: 0
}, 'OnboardingRecord');
var _default = OnboardingRecord;
exports.default = _default;
module.exports = exports.default;